import { Enum } from "./Enum";

export const NavigationTypeEnum: Enum[] = [
    { id: "basic", name: "Basic" },
    { id: "page", name: "Page" },
    { id: "article", name: "Article" },
    { id: "articleCategory", name: "Article Category" },
    { id: "product", name: "Product" },
    { id: "productCategory", name: "Product Category" },
]